var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOperationLog = function SvgOperationLog(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 50,
    height: 50,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0f0",
    d: "M0 0h50v50H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 16.875a1.875 1.875 0 1 0 1.875 1.875 1.875 1.875 0 0 0-1.875-1.875Zm0 6.25A1.875 1.875 0 1 0 18.75 25a1.875 1.875 0 0 0-1.875-1.875Zm0 6.25a1.875 1.875 0 1 0 1.875 1.875 1.875 1.875 0 0 0-1.875-1.875Zm17.5.625h-12.5a.625.625 0 0 0-.625.625v1.25a.625.625 0 0 0 .625.625h12.5a.625.625 0 0 0 .625-.625v-1.25a.625.625 0 0 0-.625-.625Zm0-12.5h-12.5a.625.625 0 0 0-.625.625v1.25a.625.625 0 0 0 .625.625h12.5a.625.625 0 0 0 .625-.625v-1.25a.625.625 0 0 0-.625-.625Zm0 6.25h-12.5a.625.625 0 0 0-.625.625v1.25a.625.625 0 0 0 .625.625h12.5a.625.625 0 0 0 .625-.625v-1.25a.625.625 0 0 0-.625-.625Z",
    fill: "#666"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOperationLog, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/operation-log.c663e2c6.svg";
export { ForwardRef as ReactComponent };